import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SportPicker } from "./SportPicker";

export interface LockerRow {
  locker_index: number;
  sport_type: string | null;
}

interface LockerListProps {
  lockers: LockerRow[];
  locationSports: string[];
  onSetSport: (lockerIndex: number, sport: string) => void;
  onDeleteLocker: (lockerIndex: number) => void;
  disabled?: boolean;
}

export function LockerList({
  lockers,
  locationSports,
  onSetSport,
  onDeleteLocker,
  disabled,
}: LockerListProps) {
  const sorted = [...lockers].sort((a, b) => a.locker_index - b.locker_index);
  const canDelete = sorted.length > 1;

  return (
    <div className="space-y-2">
      {sorted.map((locker) => (
        <div key={locker.locker_index} className="flex items-center gap-2">
          <div className="w-14 shrink-0 text-xs font-medium text-muted-foreground">
            Locker {locker.locker_index}
          </div>
          <div className="flex-1 min-w-0">
            <SportPicker
              value={locker.sport_type}
              onChange={(sport) => onSetSport(locker.locker_index, sport)}
              locationSports={locationSports}
              disabled={disabled}
            />
          </div>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            aria-label={`Remove locker ${locker.locker_index}`}
            disabled={disabled || !canDelete}
            onClick={() => onDeleteLocker(locker.locker_index)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
